import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
import { zodValidator } from "@tanstack/zod-adapter";
import { number, object, string } from "zod";

const Component = lazy(() => import("@funds/pages/funds-list"));

export const Route = createFileRoute("/(auth)/_headed/funds/_layout/")({
  component: Component,
  validateSearch: zodValidator(
    object({
      page: number().optional(),
      pageSize: number().optional(),
      search: string().optional(),
      sort: string().optional(),
    })
  ),
});
